import React from "react";

export const IconCancel = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode, stroke?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className={props?.className}
        >
            { props?.defs ? props.defs : null }
            <path fill={ props?.iconFill } d="m23 20.168-8.185-8.187L23 3.807 20.168 1l-8.182 8.179L3.81 1 1 3.81l8.186 8.196L1 20.19 3.81 23l8.203-8.192L20.193 23z"></path>
        </svg>
    )
};

export default IconCancel;
